"use client";

import { ActivityDisplayPreview } from "./previews";

type PilatesDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function PilatesDisplay({ data, participants }: PilatesDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="pilates"
      data={data}
      participants={participants}
    />
  );
}
